import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { CrudSubcategoryService } from "app/_services/MasterCrudOps/crud-subcategory.service";
import { SubcategoryWithCategory } from "app/_models/subcategories";
import { ProductOptions, CategoryOptions } from "app/_models/optionsList/options";
import { OptionslistService } from "app/_services/optionslist.service";
declare const swal: any;

@Component({
  selector: "app-edit-sub-category",
  templateUrl: "./edit-sub-category.component.html",
  styleUrls: ["./edit-sub-category.component.css"],
})
export class EditSubCategoryComponent  implements OnInit {
  editSubCategoryForm: FormGroup;
  editSubcategory: SubcategoryWithCategory;
  productOptions: ProductOptions[] = [];
  categoryOptions: CategoryOptions[] = [];
  pageNumber: number;
  pageSize: number;

  ngOnInit(): void {
    this.editSubCategoryForm = this.formBuilder.group({
      productId: [this.editSubcategory.productId ?? null, [Validators.required]],
      categoryId:[this.editSubcategory.categoryId ?? null, [Validators.required]],
      subCategoryName: [this.editSubcategory.subCategoryName ?? '', [Validators.required, Validators.maxLength(50)]],
       description: [this.editSubcategory.description ?? '', [Validators.required, Validators.maxLength(100)]],
  });
  }

  constructor(
    private readonly formBuilder:FormBuilder,
    private readonly toastr: ToastrService,
    private readonly crudSubcategoryService: CrudSubcategoryService,
    private readonly optionslistService: OptionslistService,
    private readonly dialogRef: MatDialogRef<EditSubCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.editSubcategory = JSON.parse(JSON.stringify(data.subcategory));
    this.pageNumber = data.pageNumber;
    this.pageSize = data.pageSize;
    this.optionslistService.getProductsOptions().subscribe((productOptions) => {
      this.productOptions = productOptions;
    });
    this.getCategoriesByProductId();
  }

  

  saveSubCategory() {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Update IT!",
    }).then((result) => {
      if (result === true) {
        this.updateSubCategory();
      } else {
        this.toastr.info("result not saved");
      }
    });
  }

  updateSubCategory() {
    this.crudSubcategoryService
      .updateSubCategory(
        this.editSubcategory.subCategoryId,
        this.editSubCategoryForm.value.productId,
        this.editSubCategoryForm.value.categoryId,
        this.editSubCategoryForm.value.subCategoryName,
        this.editSubCategoryForm.value.description,
        this.editSubCategoryForm.value.isConsumable
      )
      .subscribe(
        (data) => {
          if (data.didError) {
            swal({
              title: "",
              text: data.message,
              type: "error",
              confirmButtonClass: "btn btn-info",
            });
          } else {
            this.dialogRef.close(true);
            swal({
              title: "",
              text: data.message,
              type: "success",
              confirmButtonClass: "btn btn-info",
            });
            let result = {
              status: true,
              pageNumber: this.pageNumber,
              pageSize: this.pageSize,
            };
            this.dialogRef.close(result);
          }
        },
        (error) => {
          let errorMessage =
            error.error?.title ??
            error.error ??
            "Something went wrong. Please contact admin.";

          // Check if it's a validation error response with the `errors` object
          if (error.error?.errors) {
            const allErrors = Object.values(error.error.errors).flat(); // Flatten all error arrays
            if (allErrors.length > 0) {
              errorMessage = allErrors[0]; // Use the first validation message
            }
          } else if (typeof error.error === "string") {
            errorMessage = error.error;
          } else if (error.error?.title) {
            errorMessage = error.error.title;
          }
          swal({
            title: "",
            text: errorMessage,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        }
      );
  }

  close() {
    let result = {
      status: true,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
    };
    this.dialogRef.close(result);
  }

  onSelectionchange(e: any) {
    this.editSubcategory.categoryId = 0;
    this.optionslistService
      .getCategoryByProductOptions(e.value)
      .subscribe((categories) => {
        this.categoryOptions = categories;
      });
  }

  getCategoriesByProductId() {
    this.optionslistService
      .getCategoryByProductOptions(this.editSubcategory.productId)
      .subscribe((response) => {
        this.categoryOptions = response;
        for (let i = 0; i < response.length; i++) {
          if (this.categoryOptions[i].categoryId == this.data.categoryId) {
            this.categoryOptions.push(response[i]);
            break;
          }
        }
      });
  }
}
